import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import Button, { ButtonColor, ButtonSize } from '../../buttons/Button';
import css from './ServiceFooter.module.scss';
import ServiceFooterAccordion from './ServiceFooterAccordion';
import ServiceFooterLogo from './ServiceFooterLogo';
import ServiceFooterSectionBody from './ServiceFooterSectionBody';

interface Props extends React.HTMLProps<{}> {
  categories?: MerchantCategory[];
}

class ServiceFooter extends React.PureComponent<Props & InjectedIntlProps> {
  public static defaultProps: Props = {
    categories: [],
  };

  public render() {
    const { intl, categories } = this.props;
    const intlPref = 'components.common.layouts.globalFooter.serviceFooter.';

    return (
      <div className={css.ServiceFooter}>
        <div className={css.ServiceFooter__Inner}>
          <div className={css.ServiceFooter__LinkSection}>
            <ServiceFooterLogo />
            <Button
              buttonSize={ButtonSize.Medium}
              buttonColor={ButtonColor.Biz}
              className={css.ServiceFooter__Button}
              href="https://stores.jp/reserve"
            >
              {intl.formatMessage({ id: intlPref + 'buttons.startTrial' })}
            </Button>
          </div>
          <ServiceFooterAccordion
            name="footer-business"
            copy={intl.formatMessage({ id: intlPref + 'copies.business' })}
          >
            <ServiceFooterSectionBody
              rows={[
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.service',
                  }),
                  links: [
                    {
                      url: 'https://stores.jp/reserve',
                      text: intl.formatMessage({
                        id: intlPref + 'links.business',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/list_my_business',
                      text: intl.formatMessage({
                        id: intlPref + 'links.listMyBusiness',
                      }),
                    },
                    {
                      url: '/inquiry',
                      text: intl.formatMessage({
                        id: intlPref + 'links.inquiry',
                      }),
                    },
                    {
                      url: 'https://go.coubic.com/doc_feature.html',
                      text: intl.formatMessage({
                        id: intlPref + 'links.requestDoc',
                      }),
                    },
                    {
                      url: 'https://go.coubic.com/movie_demo.html',
                      text: intl.formatMessage({
                        id: intlPref + 'links.demoMovie',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/features',
                      text: intl.formatMessage({
                        id: intlPref + 'links.features',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/advantages',
                      text: intl.formatMessage({
                        id: intlPref + 'links.advantages',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/integrations',
                      text: intl.formatMessage({
                        id: intlPref + 'links.integrations',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/cases',
                      text: intl.formatMessage({
                        id: intlPref + 'links.cases',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/pricing',
                      text: intl.formatMessage({
                        id: intlPref + 'links.pricing',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/faq',
                      text: intl.formatMessage({
                        id: intlPref + 'links.faq',
                      }),
                    },
                    {
                      url: '/partnership/become_partner',
                      text: intl.formatMessage({
                        id: intlPref + 'links.partners',
                      }),
                    },
                  ],
                },
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.bizCategory',
                  }),
                  links: [
                    // TODO: merchant_categoryがpath情報もってない
                    {
                      url: 'https://stores.jp/reserve/categories/yoga',
                      text: intl.formatMessage({ id: intlPref + 'links.yoga' }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/massage_salons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.massage',
                      }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/fitness_school',
                      text: intl.formatMessage({
                        id: intlPref + 'links.fitness_school',
                      }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/online_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.online_lessons',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/hair_salons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.hairsalons',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/nail_salons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.nailsalons',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/spaces',
                      text: intl.formatMessage({
                        id: intlPref + 'links.spaces',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/exhibitions',
                      text: intl.formatMessage({
                        id: intlPref + 'links.exhibitions',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.classes',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/seminar',
                      text: intl.formatMessage({
                        id: intlPref + 'links.seminar',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/recruiting',
                      text: intl.formatMessage({
                        id: intlPref + 'links.recruiting',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/communities',
                      text: intl.formatMessage({
                        id: intlPref + 'links.community',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/events',
                      text: intl.formatMessage({
                        id: intlPref + 'links.events',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/tourism',
                      text: intl.formatMessage({
                        id: intlPref + 'links.tourism',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/experts',
                      text: intl.formatMessage({
                        id: intlPref + 'links.experts',
                      }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/cooking_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.cooking_class',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/golf_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.golf_lesson',
                      }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/language_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.language_school',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/pc_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.pc_class',
                      }),
                    },
                    {
                      url:
                        'https://stores.jp/reserve/categories/sports_lessons',
                      text: intl.formatMessage({
                        id: intlPref + 'links.sports_lesson',
                      }),
                    },
                    {
                      url: 'https://stores.jp/reserve/categories/others',
                      text: intl.formatMessage({
                        id: intlPref + 'links.other',
                      }),
                    },
                  ],
                },
              ]}
            />
          </ServiceFooterAccordion>

          <ServiceFooterAccordion
            name={'footer-brand'}
            copy={intl.formatMessage({ id: intlPref + 'copies.brand' })}
          >
            <ServiceFooterSectionBody
              rows={[
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.service',
                  }),
                  links: [
                    {
                      url: '/',
                      text: intl.formatMessage({
                        id: intlPref + 'links.brand',
                      }),
                    },
                    {
                      url: '/app',
                      text: intl.formatMessage({
                        id: intlPref + 'links.apps',
                      }),
                    },
                  ],
                },
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.category',
                  }),
                  links: categories
                    ? categories.map(cat => {
                        return {
                          url: `/categories/${cat.id}`,
                          text: cat.nameJA,
                        };
                      })
                    : [],
                },
              ]}
            />
          </ServiceFooterAccordion>

          <ServiceFooterAccordion
            name={'footer-company'}
            copy={intl.formatMessage({ id: intlPref + 'copies.company' })}
          >
            <ServiceFooterSectionBody
              rows={[
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.company',
                  }),
                  links: [
                    {
                      url: 'https://www.corp.coubic.com/',
                      text: intl.formatMessage({
                        id: intlPref + 'links.company',
                      }),
                    },
                    {
                      url: 'https://hello.hey.jp',
                      text: intl.formatMessage({
                        id: intlPref + 'links.recruit',
                      }),
                    },
                    {
                      url: 'https://www.corp.coubic.com/news',
                      text: intl.formatMessage({
                        id: intlPref + 'links.companyNews',
                      }),
                    },
                  ],
                },
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.media',
                  }),
                  links: [
                    {
                      url: '/blog',
                      text: intl.formatMessage({
                        id: intlPref + 'links.officialBlog',
                      }),
                    },
                    { url: 'https://blog.coubic.com/', text: 'ビズシル' },
                  ],
                },
                {
                  heading: intl.formatMessage({
                    id: intlPref + 'headings.stores',
                  }),
                  links: [
                    {
                      url: 'https://stores.jp/ec',
                      text: intl.formatMessage({
                        id: intlPref + 'links.storesEC',
                      }),
                    },
                    {
                      url: 'https://coiney.com',
                      text: intl.formatMessage({
                        id: intlPref + 'links.storesPayments',
                      }),
                    },
                  ],
                },
              ]}
            />
          </ServiceFooterAccordion>
        </div>
      </div>
    );
  }
}

export default injectIntl(ServiceFooter);
